const zh = {
  i18nView: {
    activitionCode: '账号激活码',
    payment: '支付方式',
    alipay: '支付宝',
    weipay: '微信支付',
    reciveMethod: '接收激活码',
    phone: '手机号',
    email: '邮箱',
    emailholder: '邮箱地址',
    phoneholder: '手机号',
    paynow: '立即支付',
    moreOptions: '更多套餐(点击前往支付)',
    optionOne: '套餐一',
    optionTwo: '套餐二',
    optionTips: '套餐一和套餐二将包含更多的RAM',
    accountTips: '*激活的账号内包括4kb内存、0.01',
    accountTips2: '的网络资源(NET) + 0.5 ',
    accountTips3: '(30天)的计算资源(CPU) 和 余额0.001 ',
    accountTips4: '',
    copyCode: '复制激活码',
    download: '下载',
    buyAgain: '再次购买',
    noPay: '没有支付',
    whypaid: '为什么需要付费？',
    paused: '服务维护中'
  }
};

export default zh;